import React, { useState, useRef, useImperativeHandle, forwardRef, useEffect } from 'react';
import {
    Modal,
    Button,
    Icon,
} from 'semantic-ui-react';
import { getDatabase, ref, onValue, off } from "firebase/database";
import { getPlanLabel, calcTotal, PAYMENT_STATUS } from '../../../utils/business';

const GOPAY_BUTTON_STATUS = {
    INIT: 'INIT',
    WAITING_FOR_GOPAY_PAYMENT: 'WAITING_FOR_GOPAY_PAYMENT'
}

export const ConfirmStep = (
    {
        paymentStatus,
        setPaymentStatus,
        billing,
        cart,
        orderId,
        orderItem,
        setLoading,
        db,
        user
    }) => {
    const [gopayButtonStatus, setGopayButtonStatus] = useState(GOPAY_BUTTON_STATUS.INIT);
    console.log(billing)
    console.log(cart)
    if (paymentStatus && paymentStatus.state == PAYMENT_STATUS.CREATED) {
        const paidAmount = calcTotal([cart.items[0]]);
        return <div style={{ textAlign: 'center' }}>
            <h3>Platbou potvrdíš objednávku</h3>
            <Button color='blue'
                disabled={gopayButtonStatus !== GOPAY_BUTTON_STATUS.INIT}
                onClick={() => {
                    const gopayUrl = paymentStatus.gw_url;

                    const width = 500;
                    const height = 700;
                    const left = window.screenX + (window.innerWidth - width) / 2;  //center position
                    const top = window.screenY + (window.innerHeight - height) / 2; //center position
                    const windowFeatures = `width=${width},height=${height},left=${left},top=${top},resizable=yes,scrollbars=yes`;
                    const gopayWindow = window.open(gopayUrl, "_blank", windowFeatures);
                    //TODO: fix closing payment window gopayWindow - and reset button state
                    setGopayButtonStatus(GOPAY_BUTTON_STATUS.WAITING_FOR_GOPAY_PAYMENT)
                    //TODO: wait for payment
                    const paymentRef = ref(
                        db, `/users/${user.uid}/orders/${orderId}/status/payment`
                    );
                    const unsubscribe = onValue(paymentRef, (snapshot) => {
                        const paymentStatus = snapshot.val();
                        if (!paymentStatus || paymentStatus.state == PAYMENT_STATUS.CREATED) {
                            return; //no value yet, still waiting for gopay payment initialization
                        }
                        console.log("New payment status:", paymentStatus);
                        setPaymentStatus(paymentStatus);
                        off(paymentRef, "value");
                        setLoading(false);
                    });
                }}
                style={{ borderRadius: 20 }}>{gopayButtonStatus === GOPAY_BUTTON_STATUS.INIT ? `Zaplatiť kartou cez GoPay ${paidAmount.total}€` : 'Čaká sa na platbu...'}</Button>
        </div >
    }

    if (paymentStatus && paymentStatus.state == PAYMENT_STATUS.PAID) {
        return <div style={{ textAlign: 'center' }}>
            <Icon name='check circle' size='huge' color='green' />
            <h3>Objednávka bola zaplatená</h3>
            <p>Ďakujeme za nákup! Tvoja verzia {getPlanLabel(orderItem.plan)} bola aktivovaná.</p>
            <p>Over si e-mail pre potvrdenie a faktúru.</p>
        </div>
    }

    return <div style={{ textAlign: 'center' }}>
        <Icon name='check circle' size='huge' color='green' />
        <h3>Objednávka bola odoslaná</h3>
        <p>Ďakujeme za nákup! Tvoja verzia {getPlanLabel(orderItem.plan)} bola dočasne aktivovaná.</p>
        <p>Over si e-mail pre potvrdenie a faktúru.</p>
    </div>
};